import { motion } from 'framer-motion';

export const Appear = ({
  children,
  isVisible,
  className,
}: {
  children: any;
  isVisible: boolean;
  className?: string;
}) => {
  const duration = 0.3;

  const variants = {
    hidden: { height: 0, opacity: 0 },
    visible: {
      height: 'auto', // Сначала анимируем высоту
      opacity: 1, // Потом анимируем прозрачность
      transition: {
        height: { duration: duration },
        opacity: { delay: duration, duration: duration },
      },
    },
    exit: {
      opacity: 0, // Сначала исчезает прозрачность
      height: 0, // Потом высота
      transition: {
        opacity: { duration: duration }, // Длительность анимации прозрачности
        height: { delay: duration, duration: duration }, // Длительность анимации высоты с задержкой
      },
    },
  };

  return (
    <motion.div
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      className={className}
      initial="hidden"
      animate={isVisible ? 'visible' : 'hidden'}
      exit="exit"
      variants={variants}
      style={{ overflow: 'hidden' }}
    >
      {children}
    </motion.div>
  );
};
